import { Injectable } from '@angular/core';
import { Language } from '../language';

@Injectable({
  providedIn: 'root'
})
export class BookingBrugesService {

  public hasNoPicture = false;

  constructor() { }

  public getPathByStudentLanguage(studentLanguage: Language): string {
    if(studentLanguage == null){
      return "en";
    }
    switch (studentLanguage.id) {
      case 1:
        return "fr";
      case 2:
        return "en";
      case 3:
        return "nl";
      case 4:
        return "es";
      case 5:
        return "pt";
    }
    return "en";
  }
}
